import * as C from '../Constants';
export function fetchStateDisData(state_name, lastUpdated){
    return function(dispatch){
        dispatch(requestSDData());
        Promise.all([
        fetch('https://api.covid19india.org/v2/state_district_wise.json'),
        fetch('https://api.covid19india.org/zones.json'),
        fetch('https://api.covid19india.org/state_test_data.json'),
         ])
        .then(([state_dis,zoneinfo,testing_data ]) => Promise.all([state_dis.json(),zoneinfo.json(),testing_data.json()]))
        .then(([state_dis_data, zoneinfo, testing_info ])=> {
          dispatch(fetch_state_dis_Success(state_dis_data, zoneinfo,state_name, testing_info, lastUpdated));
        })
       
    }
}
export const requestSDData = () => ({
    type: C.GET_TABLE_DATA,
    });
export const fetch_state_dis_Success = (state_dis_data, zoneinfo,state_name, testing_data, lastUpdated) => (
    {
    type: C.GET_TABLE_DATA_SUCCESS,
    state_dis: state_dis_data.filter(item => item['state'].toLowerCase() === state_name.toLowerCase()),
    state_zone: zoneinfo.zones.filter(item => item['state'].toLowerCase() === state_name.toLowerCase() ),
    state_testing_stats: testing_data.states_tested_data.filter(item => item['state'].toLowerCase() === state_name.toLowerCase()).slice(-1),
    lastUpdated: lastUpdated,
    });
